export const ellipsis = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export const cardActionHeader = {
  '& .MuiCardHeader-root': {
    display: 'flex',
    padding: '0px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '& .MuiCardHeader-content': {
    display: 'flex',
    flex: 'none',
  },
  '& .MuiCardHeader-action': {
    margin: '0px',
    flex: 'none',
  },
};

export const hideScrollBars = {
  /* Hide scrollbar for Chrome, Safari and Opera */
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none' /* IE and Edge */,
  scrollbarWidth: 'none' /* Firefox */,
};

export const scrollbarStyle = {
  '&::-webkit-scrollbar': {
    backgroundColor: 'transparent',
    width: '16px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#babac0',
    borderRadius: '16px',
    border: '4px solid transparent',
    backgroundClip: 'content-box',
    '&:hover': {
      backgroundColor: '#a0a0a5',
    },
  },
  '&::-webkit-scrollbar-button': { display: 'none' },
  // Firefox-specific fixes
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
  // Show scrollbar on hover for Chrome
  '&:hover::-webkit-scrollbar': {
    width: '8px',
  },
};
